// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".templates-container[data-v-8ea84a46] {\n  max-height: 70vh;\n  overflow-y: auto;\n}\n.template-list-item[data-v-8ea84a46] {\n  border-radius: 5px;\n}\n.tags-container[data-v-8ea84a46] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  min-width: 0;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  gap: 4px;\n}", ""]);
// Exports
module.exports = exports;
